import React from 'react';
import * as style from './style.module.scss';

interface MainProps {
  content: string;
}

const Main = ({ content }: MainProps) => {
  return (
    <main className={style.main}>
      <div
        className={`content ${style.main__content}`}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </main>
  );
};

export default Main;
